// extracted by mini-css-extract-plugin
module.exports = {"chart":"TrackingOrdersChart_chart_3fwiL"};